import { SVButton, SVLoader } from '@/components/core';
import CustomerDepositRules from '@/components/customers/CustomerDepositRules';
import CustomerDetailsActions from '@/components/customers/CustomerDetailsActions';
import CustomerDetailsInfo from '@/components/customers/CustomerDetailsInfo';
import CustomerDetailsView from '@/components/customers/CustomerDetailsView';
import CustomerDocuments from '@/components/customers/CustomerDocuments';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import { useGetCustomerDetails } from '@/hooks/requests/useCustomers';
import { createFullName } from '@/utils/string';
import { Card, Grid, Stack, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

export default function CustomersDetailsPage() {
  const navigate = useNavigate();
  const { uuid = '' } = useParams();
  const { customerDetails, isCustomerDetailsPending } =
    useGetCustomerDetails(uuid);
  const customerName = createFullName(
    customerDetails?.firstName,
    customerDetails?.lastName,
  );

  if (isCustomerDetailsPending) {
    return (
      <DefaultLayout header="Customer Details">
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  if (!customerDetails) {
    return (
      <DefaultLayout header="Customer Details">
        <Card>
          <Typography>
            Something went wrong retreiving the customer. Our team has been
            notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout
      header={customerName}
      buttons={
        customerDetails
          ? [
              <SVButton
                onClick={() =>
                  navigate(
                    `${ROUTES.CUSTOMERS_EDIT_PARAMS}/${customerDetails.uuid}`,
                  )
                }
                fullWidth
                key="add"
                aria-label="Edit Customer">
                Edit
              </SVButton>,
            ]
          : []
      }
      breadcrumb={[
        { label: 'Customers', href: ROUTES.CUSTOMERS },
        { label: customerName, isActive: true },
      ]}>
      <Stack spacing={2}>
        <CustomerDetailsInfo customerDetails={customerDetails} />
        <CustomerDepositRules customerDetails={customerDetails} />
        <CustomerDocuments />
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <CustomerDetailsView customerDetails={customerDetails} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <CustomerDetailsActions customerDetails={customerDetails} />
          </Grid>
        </Grid>
      </Stack>
    </DefaultLayout>
  );
}
